import { inject, Injectable, InjectionToken } from '@angular/core';
import pino, { ChildLoggerOptions, Logger } from 'pino';

export const PINO_LOG_LEVEL = new InjectionToken<string>('pino log level', {
  factory: () => {

    return 'info';

  },
  providedIn: 'root',
});

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  level: string;

  logger: Logger;

  constructor() { 

    this.level = inject(PINO_LOG_LEVEL);

    this.logger = pino({
      level: this.level,
    });

  }

  child(bindings: pino.Bindings, options?: ChildLoggerOptions) {

    return this.logger.child(bindings, options);

  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  debug(obj: any, msg?: string, ...args: Array<any>) {

    return this.logger.debug(obj, msg, args);

  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error(obj: any, msg?: string, ...args: Array<any>) {

    return this.logger.error(obj, msg, args);

  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  info(obj: any, msg?: string, ...args: Array<any>) {

    return this.logger.info(obj, msg, args);

  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  log(obj: any, msg?: string, ...args: Array<any>) {

    return this.logger.info(obj, msg, args);

  }

}
